import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../types/multi-error';
import { graphqlClient } from '../graphql-client';

const MUTATION = gql`
    mutation UserLogin($email: String!, $password: String!, $oneTimeCode: Boolean!){
        user_login (email: $email, password: $password, one_time_code: $oneTimeCode) {
            configurationFinished: configuration_finished,
            accessToken: access_token,
        }
    }
`;

export async function login(email: string, password: string, oneTimeCode: boolean): Promise<{ configurationFinished: boolean, accessToken: string }> {
    const result: FetchResult<{ user_login: { configurationFinished: boolean, accessToken: string }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { email, password, oneTimeCode },
        errorPolicy: 'all',
    });

    if(!result.data || (result.errors && result.errors.length)) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_login;
}
